import { createStore } from "vuex";
import axios from "axios";
import qs from "qs";

const store = createStore({
  state: {
    pageData: null,
    pageSlides: null,
    pageList: null,
    pageListMeta: null,
    hideFooter: false,
    pageRoutes: null,
    showNavigation: false,
    showDropdown: false,
    openDropdown: false,
    loadedTitle: false,
    loadedSlideshow: false,
    siteSettings: null,
    siteSettingsLoaded: false,
  },
  mutations: {
    setPageData(state, payload) {
      if (payload.route_options) {
        payload.options = JSON.parse(payload.route_options);
        delete payload.route_options;
      }
      // Reset the p parameter if it exists in the query object
      // This ensures pagination starts fresh when navigating to a new route
      if (payload.options?.items?.query?.p !== undefined) {
        payload.options.items.query.p = 0;
      }
      state.pageData = payload;
    },
    setPageSlides(state, payload) {
      state.pageSlides = payload;
    },
    setPageList(state, payload) {
      if (payload) state.pageList = payload.content;
      else state.pageList = null;
      if (payload) state.pageListMeta = payload.meta;
      else state.pageListMeta = null;
    },
    pushPageList(state, payload) {
      if (payload.content) {
        payload.content.forEach((item) => state.pageList.push(item));
        state.pageListMeta = payload.meta;
      } else {
        state.hideFooter = false;
        state.pageListMeta = payload.meta;
      }
    },
    setPageRoutes(state, payload) {
      payload.forEach((page, index) => {
        payload[index].options = JSON.parse(page.route_options);
        delete payload[index].route_options;
        // Reset the p parameter if it exists in the query object
        // This prevents mutations from persisting in pageRoutes
        if (payload[index].options?.items?.query?.p !== undefined) {
          payload[index].options.items.query.p = 0;
        }
      });
      state.pageRoutes = payload;
    },
    setSiteSettings(state, payload) {
      state.siteSettings = payload;
    },
    setSiteSettingsLoaded(state, value) {
      state.siteSettingsLoaded = value;
    },
  },
  getters: {
    pageData: (state) => state.pageData,
    pageList: (state) => state.pageList,
    pageListMeta: (state) => state.pageListMeta,
    pageRoutes: (state) => state.pageRoutes,
    pageSlides: (state) => state.pageSlides,
    hideFooter: (state) => state.hideFooter,
    showNavigation: (state) => state.showNavigation,
    loadedSlideshow: (state) => state.loadedSlideshow,
    windowDimensions: (state) => state.windowDimensions,
    siteSettings: (state) => state.siteSettings,
  },
  actions: {
    // FETCH ITEMS
    async fetchItems({ commit }, payload) {
      if (!payload.action) commit(payload.target, null);

      await axios
        .post("/api/" + payload.table + "/", qs.stringify(payload.query))
        .then((res) => {
          if (!payload.action) {
            commit(payload.target, res.data);
          } else {
            commit("pushPageList", res.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async fetchSiteSettings({ commit, state }) {
      if (state.siteSettingsLoaded) return;

      commit("setSiteSettingsLoaded", true);

      await axios
        .post("/api/settings/", qs.stringify({}))
        .then((res) => {
          const rows = res.data.content ?? res.data.data ?? [];
          const list = Array.isArray(rows) ? rows : rows ? [rows] : [];
          const row = list.length ? list[list.length - 1] : null;
          commit("setSiteSettings", row);
        })
        .catch((err) => {
          console.log(err);
          commit("setSiteSettings", null);
        });
    },
  },
  modules: {},
});

export default store;
